<div class="col-md-12">
    <hr>
    <form [formGroup]="dpIntergrationForm" id="dp-intergration-form">
        <div id="sub-heading">
            <div>
                <p class="h5"><b>{{dpData.name}}</b></p>
            </div>

        </div>
        <div class="row justify-content-start" id="inputRow">
            <div class="col-2">

                <label for class="font-weight-normal">Unique ID
                    <span style="color: #FF0000">*</span>
                </label>
            </div>
            <div class="col-4 text-left">
                <input formControlName="uniqueId" class="form-control" type="text" placeholder="Unique Id"
                    [ngClass]="{ 'is-invalid': f.uniqueId.touched && f.uniqueId.invalid}">
                <div *ngIf="f.uniqueId.invalid" class="invalid-feedback">
                <div *ngIf="f.uniqueId.errors.required">
                    Unique Id is required.
                </div>
            </div>

            </div>
        </div>

        <div class="row justify-content-start" id="inputRow">
            <div class="col-2">

                <label for class="font-weight-normal">Client Key
                    <span style="color: #FF0000">*</span>
                </label>
            </div>
            <div class="col-4 text-left">
                <input  formControlName="clientKey" class="form-control" type="text" placeholder="Client Key"
                    [ngClass]="{ 'is-invalid': f.clientKey.touched && f.clientKey.invalid}">
                <div *ngIf="f.clientKey.invalid" class="invalid-feedback">
                <div *ngIf="f.clientKey.errors.required">
                    Client Key is required.
                </div>
            </div>

            </div>
        </div>
    </form>
    <br>
</div>